import { UploadIcon } from 'lucide-react'
import { useDropzone } from 'react-dropzone'

import { Button } from '@/components/button/button'

import { cn } from '@/lib/utils'

import { UploadGraphics } from './upload-graphics'

export interface UploadDocumentFileInputProps {
  onSelect: (files: File[]) => void
}

export const UploadDocumentFileInput = ({ onSelect }: UploadDocumentFileInputProps) => {
  const handleDrop = (acceptedFiles: File[]) => {
    if (acceptedFiles.length === 0) {
      return
    }

    onSelect(acceptedFiles)
  }

  const { getRootProps, getInputProps } = useDropzone({
    onDrop: handleDrop,
    accept: {
      'application/pdf': ['.pdf'],
      'image/png': ['.png'],
      'image/jpeg': ['.jpg'],
    },
  })

  return (
    <div
      className={cn('flex flex-col items-center', 'py-[40px]', 'rounded-[10px] border border-slate-300', 'bg-slate-50')}
      {...getRootProps()}
    >
      <input {...getInputProps()} />
      <UploadGraphics />
      <p className={cn('text-base font-medium text-black', 'mt-4')}>
        Select or drag your file here (PDF, PNG, JPEG formats only)
      </p>
      <Button type="button" variant="default" className={cn('w-[140px]', 'mt-4')}>
        <span className={cn('flex items-center gap-x-2')}>
          <UploadIcon size={16} />
          Upload file
        </span>
      </Button>
    </div>
  )
}
